import { IconButton, Stack } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { headerContainerSx } from '../consts/styles.consts'

interface DrawerHeaderProps {
  onClose: () => void
  onBack?: () => void
  title: string
}

const DrawerHeader: React.FC<DrawerHeaderProps> = ({
  onClose,
  onBack,
  title,
}) => (
  <Stack
    direction={'row'}
    justifyContent={'space-between'}
    alignItems={'center'}
    padding={'10px 8px'}
    sx={headerContainerSx}
  >
    <Stack gap={'12px'} direction={'row'}>
      {onBack && (
        <img
          alt={'Назад'}
          src={getImageSrc('arrow-left')}
          className={'pointer'}
          onClick={onBack}
        />
      )}
      <h3>{title}</h3>
    </Stack>
    <IconButton
      sx={{ padding: '8px', height: 'max-content !important' }}
      onClick={onClose}
    >
      <img
        alt={'Закрыть'}
        src={getImageSrc('close-light')}
        className={'pointer'}
      />
    </IconButton>
  </Stack>
)

export default observer(DrawerHeader)
